import React, { useState, useEffect } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from '../axios';
import BreadcrumbBg from '../img/banner/breadcrumb-bg.jpg'
import HeaderSecond from '../HeaderSecond';


const Disclaimer = () => {
  // console.log("Create Event page");
  const navigate = useNavigate();

  const handleBackToHome = () => {
    localStorage.removeItem('EventViewFlag');
    localStorage.removeItem('EventDetailsId');

    const CountryCode = localStorage.getItem('CountryCode');
    const CountryName = localStorage.getItem('Country');
    navigate('/' + CountryCode + '/' + CountryName);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <>
      <ToastContainer theme="colored" />

      <HeaderSecond />
      <main className="main__content_wrapper">
        {/* Start breadcrumb section */}
        <section className="breadcrumb__section breadcrumb__bg" style={{ backgroundImage: `url(${BreadcrumbBg})` }} >
          <div className="container">
            <div className="row row-cols-1">
              <div className="col">
                <div className="breadcrumb__content">
                  <h1 className="breadcrumb__content--title text-white mb-10">
                    Disclaimer
                  </h1>
                  <ul className="breadcrumb__content--menu d-flex">
                    <li className="breadcrumb__content--menu__items">
                      <div className="text-white" onClick={(e) => handleBackToHome(e)}>
                        Home
                      </div>
                    </li>
                    <li className="breadcrumb__content--menu__items">
                      <span className="text-white">Disclaimer</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End breadcrumb section */}

        <section className="section--padding pt-5">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 my-5" style={{ textAlign: "justify" }}>
                <p>YOU EXPRESSLY UNDERSTAND AND AGREE THAT:</p><p>Your use of the service is at your sole risk. The service is provided on an “as is” and “as available” basis.&nbsp;RACES - a wholly-owned&nbsp;Division of YouTooCanRun Sports Managemen<strong>t&nbsp;</strong>Pvt Ltd and its subsidiaries, affiliates, officers, employees, agents, partners and licensors expressly disclaim all warranties of any kind, whether express or implied, including, but not limited to the implied warranties of merchantability, fitness for a particular purpose and non-infringement.</p><p>RACES - a wholly-owned&nbsp;division of&nbsp;&nbsp;YouTooCanRun Sports Management Pvt Ltd<strong>&nbsp;</strong>and its subsidiaries, affiliates, officers, employees, agents, partners and licensors make no warranty that (a) The service will meet your requirements; (b) The service will be uninterrupted, timely, secure or error-free; (c) The results that may be obtained from the use of the service will be accurate or reliable; (d) The quality of any products, services, information or other material purchased or obtained by you through the service will meet your expectations; and (e) Any errors in the software will be corrected.</p><p>Any material downloaded or otherwise obtained through the use of the service is accessed at your own discretion and risk, and you will be solely responsible for any damage to your computer system or loss of data that results from the download of any such material.</p><p>No advice or information, whether oral or written, obtained by you from&nbsp;RACES - a wholly-owned&nbsp;division of&nbsp;&nbsp;YouTooCanRun Sports Management Pvt Ltd or through or from the service shall create any warranty not expressly stated in the Terms &amp; Conditions.</p><p>&nbsp;</p><p>Without the legalese:</p><p>What we mean by the above in simple language is this</p><p>– We will take every effort to provide you with the best services and see that you are getting a fair deal when dealing with us.</p><p>– While doing so, there may be some factors within our control and many factors that may not be within our control. We will ensure that we make a sincere effort to correct everything within our control.</p>
              </div>
            </div>
          </div>
        </section>

      </main >

    </>
  )
}

export default Disclaimer;

